import React from 'react'
import { isMobile } from 'react-device-detect'

import ProfileSection from 'app/common/pixel-menu/_comp/ProfileSection'
import {
  DcBreadcrumbs,
  DcButton,
  DcFlexBox,
  DcOverlaySlider,
  PixelDate,
  PixelPageContainer,
  PixelTable,
  Section,
  SectionContent,
} from 'pixel-base'
import { get, getAllUsers, IUser } from 'utils/api-routes.util'
import CheckIcon from 'utils/icons/check-icon'
import PlusIcon from 'utils/icons/plus-icon'
import XmarkIcon from 'utils/icons/xmark-icon'

import AddNewUser from './component/AddNewUser'
import UserDetails from './UserDetails'

const columns = [
  {
    dataKey: 'name',
    name: 'Name',
    sortable: true,
    selector: (row) => row.name,
  },
  {
    dataKey: 'role',
    name: 'Role',
    sortable: true,
    selector: (row) => row.user_type.description,
  },
  {
    dataKey: 'user_email',
    name: 'Email',
    sortable: true,
    selector: (row) => (row.user_email ? row.user_email : '--'),
  },
  {
    dataKey: 'created_at',
    name: 'Created On',
    sortable: true,
    selector: (row) => (
      <PixelDate value={row.created_at.date} format={'dateWithTime'} />
    ),
  },
  {
    dataKey: 'last_active',
    name: 'Last Active',
    sortable: true,
    selector: (row) =>
      row.last_active ? (
        <PixelDate value={row.last_active.date} format={'dateWithTime'} />
      ) : (
        '--'
      ),
  },
  {
    dataKey: 'active',
    name: 'Is Active ?',
    sortable: true,
    selector: (row) =>
      row.active ? (
        <CheckIcon color="green" size={16} />
      ) : (
        <XmarkIcon color="red" size={16} />
      ),
  },
]
const breadcrumbs = [
  {
    name: 'Settings',
    active: false,
  },
  {
    name: 'Users',
    active: true,
  },
]

const Users = () => {
  const [users, setUsers] = React.useState<IUser[]>([])
  const [showNewModal, setShowNewModal] = React.useState(false)
  const [showDetailModal, setShowDetailModal] = React.useState(false)
  const [userId, seUserId] = React.useState(null)
  const [userRole, setUserRole] = React.useState<
    {
      id: number
      type: string
      description: string
      count: number | null
    }[]
  >([])
  const [tableLoading, setTableLoading] = React.useState(true)
  interface IUsersResponse {
    _meta: {
      count: number
    }
    data: IUser[]
  }

  const getUsers = () => {
    setTableLoading(true)
    getAllUsers().subscribe((res) => {
      const response = res.response as IUsersResponse
      setUsers(response.data)
      setTableLoading(false)
    })
  }

  const getAllUsersRole = () => {
    get('/settings/users/roles').subscribe((res) => {
      const response = res.response as {
        data: {
          id: number
          type: string
          description: string
          count: number | null
        }[]
      }
      setUserRole(response.data)
    })
  }
  React.useEffect(() => {
    getUsers()
    getAllUsersRole()
  }, [])

  const onRowClicked = (row: IUser) => {
    // navigate(`/admin/users/${row.id}`)
    seUserId(row.id)
    setShowDetailModal(true)
  }
  const handleCloseModal = (data: IUser) => {
    setUsers([data, ...users])
    setShowNewModal(false)
  }
  return (
    <>
      <DcFlexBox
        height="60px"
        fontSize="16px"
        style={{
          fontSize: '16px',
          padding: '8px 0px',
          borderBottom: '1px solid #e5e5e5',
        }}
      >
        <DcFlexBox
          justifyContent="space-between"
          alignItems="center"
          padding=".5rem 20px"
          height="auto"
        >
          <DcBreadcrumbs fontSize="16px" data={breadcrumbs} />

          <ProfileSection />
        </DcFlexBox>
      </DcFlexBox>

      <PixelPageContainer style={{ padding: '0 ' }}>
        <Section style={{ padding: '0px' }}>
          <SectionContent style={{ padding: '0px', borderRadius: '0px' }}>
            <DcFlexBox
              justifyContent="flex-end"
              alignItems="center"
              padding=" 5px 20px"
              height="auto"
            >
              <DcButton
                onClick={() => {
                  setShowNewModal(true)
                }}
                size="sm"
              >
                <PlusIcon color="white" size={18} /> Add User
              </DcButton>
            </DcFlexBox>
          </SectionContent>
        </Section>
        <Section
          style={{
            padding: '20px',
            height: 'calc(100vh - 100px)',
            overflow: 'auto',
          }}
          isMobile={isMobile}
        >
          <SectionContent isMobile={isMobile}>
            <PixelTable
              highlightOnHover={true}
              // isSearchable={true}
              pointerOnHover={true}
              columns={columns}
              data={users}
              progressPending={tableLoading}
              onRowClicked={onRowClicked}
              fixedHeader
              fixedHeaderScrollHeight="calc(100vh - 212px)"
            />
          </SectionContent>
        </Section>
      </PixelPageContainer>
      <DcOverlaySlider
        title={'Create User'}
        onClose={() => setShowNewModal(false)}
        isOpen={showNewModal}
        width="40%"
      >
        <SectionContent>
          {showNewModal && (
            <AddNewUser
              handleClose={handleCloseModal}
              userRole={userRole}
              // defaultStatuses={defaultStatuses}
            />
          )}
        </SectionContent>
      </DcOverlaySlider>

      <DcOverlaySlider
        title={'User Detail'}
        onClose={() => setShowDetailModal(false)}
        isOpen={showDetailModal}
        padding="0px"
      >
        {userId !== null && (
          <UserDetails
            userId={userId}
            setShowDetailModal={setShowDetailModal}
          />
        )}
      </DcOverlaySlider>
    </>
  )
}

export default Users
